import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'
import { swiperEvents } from '../../swiper/swiperEvents'

Swiper.use([Navigation, Pagination])
Swiper.extendDefaults({ speed: 500 })

try {
  new Swiper('[data-dedic-swiper]', {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 16,
    observer: true,
    pagination: {
      clickable: false,
      el: '[data-dedic-tariff-progress-bar]',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '[data-dedic-servers-swiper-next]',
      prevEl: '[data-dedic-servers-swiper-prev]',
    },
    on: {
      breakpoint: function (swiper) {
        if (swiper.currentBreakpoint === '1440') {
          this.slideTo(0)
          this.disable()
          this.el.querySelector('.dedicated-servers__swiper-list').style.cursor = 'auto'
        } else {
          this.enable()
          this.el.querySelector('.dedicated-servers__swiper-list').style.cursor = 'grab'
        }
      },
    },

    breakpoints: {
      1440: {
        enabled: false,
      },
    },
  })
} catch (e) {
  console.log(e.message, 'dedic swiper')
}

try {
  new Swiper('[data-dedic-advantages-swiper]', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    observer: true,
    slideVisibleClass: 'isVisible',
    pagination: {
      clickable: true,
      el: '[data-dedic-advantages-servers-swiper-pagination]',
      type: 'bullets',
    },
    navigation: {
      nextEl: '[data-dedic-advantages-servers-swiper-next]',
      prevEl: '[data-dedic-advantages-servers-swiper-prev]',
    },
    breakpoints: {
      500: {
        slidesPerView: 1.5,
      },
      700: {
        spaceBetween: 25,
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 35,
      },
      1550: { spaceBetween: 0, slidesPerView: 4, slidesPerGroup: 1 },
    },
    on: swiperEvents,
  })
} catch (e) {
  console.log(e.message, 'dedic advantages swiper')
}
